export function buildDauMauChartData(rawData, label = "ユーザー数") {
    const labels = Object.keys(rawData);
    const values = Object.values(rawData);
    return {
        labels,
        datasets: [{
                label,
                data: values,
                fill: true,
                tension: 0.35,
                backgroundColor: "rgba(107, 138, 253, 0.1)",
                borderColor: "#6b8afd",
                pointBackgroundColor: "#6b8afd",
                pointRadius: 3
            }]
    };
}
export const DEFAULT_MONTHLY_CHART = {
    labels: Array.from({
        length: 31
    }, (_, i) => `${i + 1}日`),
    datasets: [{
            label: "ユーザー数",
            data: Array(31).fill(0),
            fill: true,
            tension: 0.35,
            backgroundColor: "rgba(107, 138, 253, 0.1)",
            borderColor: "#6b8afd",
            pointBackgroundColor: "#6b8afd",
            pointRadius: 0
        }]
};
export const DEFAULT_MONTHLY_BAR_CHART = {
    labels: Array.from({
        length: 31
    }, (_, i) => `${i + 1}日`),
    datasets: [{
            label: "AIレコメンド",
            data: Array(31).fill(0),
            backgroundColor: "#93c5fd",
            borderColor: "#60a5fa",
            borderWidth: 1,
            barThickness: 14
        }, {
            label: "手動レコメンド",
            data: Array(31).fill(0),
            backgroundColor: "#86efac",
            borderColor: "#4ade80",
            borderWidth: 1,
            barThickness: 14
        }]
};
// utils/common-chart.ts
export const buildRecommendChartData = data => {
    const labels = Object.keys(data);
    return {
        labels,
        datasets: [{
                label: "手動レコメンド",
                data: labels.map(d => data[d].manual),
                backgroundColor: "rgba(122, 199, 122, 0.7)",
                borderColor: "#7ac77a",
                borderWidth: 1,
                barThickness: 18
            }, {
                label: "AIレコメンド",
                data: labels.map(d => data[d].ai),
                backgroundColor: "rgba(107, 138, 253, 0.7)",
                borderColor: "#6b8afd",
                borderWidth: 1,
                barThickness: 18
            }]
    };
};
export const columnUserVisitPage = [{
        title: "#",
        dataIndex: "key",
        width: 60,
        render: (_value, _record, index) => index + 1
    }, {
        title: "項目",
        dataIndex: "email",
        ellipsis: true
    }, {
        title: "アクセスページ",
        dataIndex: "path",
        ellipsis: true
    }, {
        title: "詳細",
        dataIndex: "visit_ip",
        width: 160
    }];
